import gql from 'graphql-tag'
import { GET_LIST, GET_ONE } from 'react-admin'
import { upsertQuery } from '~/helpers'

const fields = gql`
  {
    id
    uid
    start
    end
    title
    type
    allDay
    location
    notes
    appointment_customer {
      id
      customer_id
      customer {
        firstname
        lastname
        informal_salutation
        phones {
          id
          type
          number
        }
        emails {
          id
          type
          email
        }
      }
    }
    appointment_boat {
      id
      boat_id
      boat {
        name
        model
      }
    }
    appointment_user {
      id
      user_id
      user {
        id
        displayName
        email
      }
    }
  }
`

export default upsertQuery(
  {
    [GET_ONE]: {
      buildFields: fields,
    },
    [GET_LIST]: {
      buildFields: fields,
    },
  },
  {
    relations: ['appointment_customer', 'appointment_boat', 'appointment_user'],
  }
)
